import { render, staticRenderFns } from "./authone.vue?vue&type=template&id=004c37d0&scoped=true&"
import script from "./authone.vue?vue&type=script&lang=js&"
export * from "./authone.vue?vue&type=script&lang=js&"
import style0 from "./authone.vue?vue&type=style&index=0&id=004c37d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c37d0",
  null
  
)

export default component.exports